/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

export const commentData=[
    {
        id:"post-1",
        post:"User-111",
        content: "Some comment here"
    },
    {
        id:"post-2",
        post:"User-112",
        content: "Some comment here"
    },
    {
        id:"post-3",
        post:"User-113",
        content: "Some comment here"
    },
    {
        id:"post-4",
        post:"User-114",
        content: "Some comment here"
    }
]